import React, { useState } from 'react'
import Snackbar from '@mui/material/Snackbar'
import Link from 'next/link'
import cx from 'classnames'
import styles from './SingleVideoContent.module.css'
import uuid from 'react-uuid'
import { jDateFormatter } from '../../../lib/dateFormater'
import Image from 'next/image'
import downloadSvg from '../../../images/VideospageImages/downloadIcon.svg'
import shareSvg from '../../../images/VideospageImages/shareIcon.svg'
import { slugGenerator } from '../../../lib/slugGenerator'

const SingleVideoContent = ({ data }) => {
  // toast handler after link copy
  const [openToast, setOpenToast] = useState(false)
  const onShareHandler = () => {
    if (data.id && data.title) {
      navigator.clipboard.writeText(
        `https://about.digikala.com/videos/vod-${data?.id}/${slugGenerator(
          data.title
        )}` + '/'
      )
      openToastHandler()
    }
  }
  const openToastHandler = () => {
    setOpenToast(true)
  }
  const closeToastHandler = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenToast(false)
  }
  // end of toast handler after link copy
  return (
    <div className={cx(styles.container)}>
      <Snackbar
        open={openToast}
        autoHideDuration={2000}
        onClose={closeToastHandler}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        message={
          <div className='w-100 d-flex align-items-center justify-content-between'>
            <span className={cx(styles.toasTextStyles, 'd-flex', 'w-100')}>
              لینک ویدیو کپی شد!
            </span>
          </div>
        }
      />
      <div className='w-100 d-flex flex-column align-items-center justify-content-start'>
        <div
          className={cx(
            styles.videoContainer,
            'd-flex',
            'flex-column',
            'align-items-center',
            'justify-content-start',
            'w-100'
          )}
        >
          <div
            className={cx(
              styles.videoWrapper,
              'd-flex',
              'align-items-center',
              'justify-content-center',
              'w-100'
            )}
          >
            <video
              autoPlay={true}
              controls={true}
              poster={data?.thumbnail_img}
              className={cx(styles.videoPlayer)}
            >
              <source src={data?.link_720} />
            </video>
          </div>
          <div
            style={{
              marginTop: '17px',
              marginBottom: '22px'
            }}
            className={cx(
              styles.tagContaienr,
              'd-flex',
              'w-100',
              'align-items-center',
              'justify-content-start',
              'px-3',
              'px-lg-0',
              'flex-wrap'
            )}
          >
            {data?.tags?.map((t, indx) => (
              <button
                key={uuid()}
                className={cx(
                  styles.tagbtnStyles,
                  'd-flex',
                  'align-items-center',
                  'justify-content-center',
                  'pt-1'
                )}
              >
                <Link href={`/videos?tag=${t.id}`}>{t.title}</Link>
              </button>
            ))}
          </div>
          <h1
            className={cx(
              styles.mainTitle,
              'text-start',
              'w-100',
              'px-3',
              'px-lg-0'
            )}
          >
            {data?.title}
          </h1>
          <div className='w-100 d-flex align-items-center justify-content-start'>
            <span className={cx(styles.dateStyles, 'px-3', 'px-lg-0')}>
              {jDateFormatter(data?.date_published)}
            </span>
          </div>
          <div
            style={{ marginTop: '30px', columnGap: '10px' }}
            className={cx(
              styles.btnContainer,
              'w-100',
              'd-flex',
              'align-items-center',
              'justify-content-start',
              'px-3',
              'px-lg-0'
            )}
          >
            <a
              href={String(data?.link_original).replace(
                'https://about.digikala.com',
                ''
              )}
              // target="_blank"
              download
            >
              <button
                className={cx(
                  styles.btnSyles,
                  'd-flex',
                  'align-items-center',
                  'justify-content-center'
                )}
              >
                دانلود
                <Image src={downloadSvg} alt={data?.title} />
              </button>
            </a>
            <button
              onClick={onShareHandler}
              className={cx(
                styles.btnSyles,
                'd-flex',
                'align-items-center',
                'justify-content-center'
              )}
            >
              اشتراک گذاری
              <Image src={shareSvg} alt={data?.title} />
            </button>
          </div>
          <div
            className={cx(
              styles.videoText,
              'd-flex',
              'align-items-center',
              'justify-content-start'
            )}
          >
            <p className='mb-2'>{data?.description}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SingleVideoContent
